import { render, staticRenderFns } from "./ApprovalRoot.vue?vue&type=template&id=294945c0"
import script from "./ApprovalRoot.vue?vue&type=script&lang=js"
export * from "./ApprovalRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports